// extracted by mini-css-extract-plugin
module.exports = {"companyLogoWrap":"TestujLogo_companyLogoWrap__1l4me","companyLogo":"TestujLogo_companyLogo__XD_VJ"};